import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolveUnmatchedGoodsService {
  private httpOptions = {
    headers: new HttpHeaders({
      'contet-type': 'multipart/form-data',
    })
  };

  constructor(
    private http: HttpClient
  ) { }

  public uploadUnmatchedGoodsList(file: FormData) {
    return this.http.post(environment.apiEndPoint + 'api/solve-unmatched-goods/upload-list', file, this.httpOptions) as Observable<any>;
  }

  public downloadGoodsList(fileName: string) {
    const httpOptions: any = {
      responseType: 'blob',
      headers: new HttpHeaders({
        'contet-type': 'application/octet-stream',
      }),
      params: { 'fileName': fileName }
    };
    return this.http.get(environment.apiEndPoint + 'api/solve-unmatched-goods/download-list', httpOptions) as Observable<any>;
  }

  public checkUnmatchedGoodsListExist(param: any): Observable<any> {
    const httpOptions: any = {
      params: param
    };
    return this.http.get(environment.apiEndPoint + 'api/solve-unmatched-goods/check-unmatched-list-exist', httpOptions) as Observable<any>;
  }

  public downloadUnmatchedGoodsList(param: any): Observable<any> {
    const httpOptions: any = {
      responseType: 'blob',
      params: param
    };
    return this.http.get(environment.apiEndPoint + 'api/solve-unmatched-goods/download-unmatched-list', httpOptions) as Observable<any>;
  }

  /**
   * 画面初期化処理
   */
  public initialize(organization: string): Observable<any> {
    const httpOptions: any = {
      params: { 'organization': organization }
    };
    return this.http.get(environment.apiEndPoint + 'api/solve-unmatched-goods/initialize', httpOptions) as Observable<any>;
  }
}
